import { ProductPageLayout } from '../components/ProductPageLayout';

export function NsfwAiPage() {
    return <ProductPageLayout productId="nsfw-ai" />;
}
